import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "300px",
    "padding-left": "20px"
  }
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 提交 ");

import { ref } from 'vue';
import ChangePwd from '@/components/ChangePwd.vue';
export default {
  name: 'AccountSafe',

  setup(__props) {
    const changePwdRef = ref();

    function submit() {
      changePwdRef.value.submit();
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ChangePwd, {
        ref_key: "changePwdRef",
        ref: changePwdRef
      }, null, 512), _createVNode(_component_el_button, {
        type: "primary",
        style: {
          "margin-left": "100px"
        },
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      })]);
    };
  }

};